import { CardBlock, evaluateSelector } from '@coast/schemas';
import { API } from '@shared/types/api';
import { nonEmptyBlocks, nonRedactedBlocks } from './blockRenderVisibility';
import { CommonFields, Fields } from './types';
import { defaultEvaluationContext } from './utils/tokens';

export function getBlocksToRender(
  blocks: CardBlock[],
  card: API.CardFragment,
  fields: CommonFields & Fields,
  canReadThread: boolean,
  canCreateThread: boolean,
  canUpdateCard: boolean,
  printing: boolean,
) {
  const filters: Array<(block: CardBlock) => boolean> = [
    nonRedactedBlocks(card),
    nonEmptyBlocks(fields, canReadThread, canCreateThread, canUpdateCard, printing),
    // @ts-expect-error -- strict migration
    block => evaluateSelector(block.selector, fields, defaultEvaluationContext),
  ];

  return blocks.filter(block => filters.every(ff => ff(block)));
}
